__turbopack_context__.v({
  "disabledButtons": "DefaultViewButton-module__PB_sgq__disabledButtons",
  "enabledButtons": "DefaultViewButton-module__PB_sgq__enabledButtons",
});
